import React from 'react';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import messages from '../../../res/translations/messages';

const SaveButton = ({disabled = false}) => (
    <div className="btn-group">
        <button type="submit" className={classNames('btn btn-primary')} disabled={disabled}>
            <FontAwesomeIcon icon="save" fixedWidth /> <FormattedMessage {...messages.surveys.button.save} />
        </button>
    </div>
);

export default SaveButton;
